import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FilterBarService {
  private _isFilterBarOpened$ = new Subject<boolean>();

  constructor() {
    this._isFilterBarOpened$.next(false);
  }

  toggleFilterBar(value: boolean) {
    this._isFilterBarOpened$.next(value);
  }

  get isFilterBarOpened(): Observable<boolean> {
    return this._isFilterBarOpened$;
  }
}

